import { createMigration } from './utils';

const suffixes = [
    ':talking_head_Cutaway',
    ':talking_head_Stat',
    ':talking_head_text',
    ':talking_head_Icon',
];

const migrateAsset = (map, path) => {
    const asset = map.getIn(path);
    if (asset && asset.get('classType') === 'TimeAwareMediaAsset' && asset.get('linkToSceneGroup') === true) {
        map.deleteIn(path);
    }
};

export const migrationTo9_183 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateScene(scene) {
        return scene.withMutations(map => {
            // skip if not talking_head_insert
            const sceneCategory = map.get('sceneCategory') as string;
            if (sceneCategory !== 'talking_head_insert') {
                return;
            }

            // skip if scene design not what we want
            const sceneDesign = map.get('sceneDesign') as string;
            const requiresMigration = suffixes.find(suffix => sceneDesign.endsWith(suffix));
            if (!requiresMigration) {
                return;
            }

            // update scene category
            map.set('sceneCategory', 'voiceover');

            // delete linked media
            map.get('children', []).forEach((_, c) => {
                const path = ['children', c];
                migrateAsset(map, path);
            });
            map.get('subslides', []).forEach((subslide, s) => {
                subslide.get('children', []).forEach((_, c) => {
                    const path = ['subslides', s, 'children', c];
                    migrateAsset(map, path);
                });
            });
        });
    },
});
